'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { creatpassowrd } from '../(protected)/services/forgotpassword/passwordcreation';
import Cookies from "js-cookie";
const { Checkuserexistandsendmail } = await creatpassowrd();
export default function ForgotpasswordPage() {

  const router = useRouter();
  const [emaild, setemaild] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!emaild) {
      setError("Please enter Email Id.");
      return;
    }

    setLoading(true);

    try {
      // Pass the email (username) to the function
      const userexist = await Checkuserexistandsendmail(emaild);
      if (userexist.success) {
        alert("Reset password link as been sent to your mail");
        setemaild("");
      }
      else
        alert("User details not found");
      // Handle response if needed

    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="w-full max-w-md p-2">
      <div className="bg-white shadow-md rounded-lg px-6 py-10">
        <div className="flex flex-col items-center mb-3">
          <div className="flex flex-col items-center mb-6">
            <div className="mb-4">
              <img
                src="/logo.svg"
                alt="Company Logo"
                width={100}
                height={100}
                className="object-contain"
              />
            </div>

            {/* Reset Password Heading */}
            <div className="text-orange-500 font-bold text-lg mb-2 text-center">
              Reset Password
            </div>

            {/* Description */}
            <div className=" text-sm text-center">
              Enter your registered email address to reset your password
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-2" aria-label="Login form">
          <div className="relative mb-3">
            <input
              type="text"
              id="emailid"
              name='emailid'
              value={emaild}
              onChange={(e) => setemaild(e.target.value)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none transition-all duration-300 focus:border-orange-500"
              placeholder=" "
            />
            <label
              htmlFor="emailid"
              className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1"
            >
              Email Id
            </label>
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}

          <div className="flex flex-col items-center justify-between">
            <button
              type="submit"
              className="w-full h-[46px] bg-gradient-to-br from-orange-500 to-orange-600 text-white uppercase rounded-md flex items-center justify-center hover:from-orange-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 cursor-pointer my-1 tracking-wide"
              disabled={loading}
            >
              <span className="text-sm">
                {loading ? 'Sending mail...' : 'Send Password Instruction'}
              </span>
            </button>

            {/* Centered Redirect Link */}
            <a
              href="/login"
              className="text-sm mt-2 hover:underline text-center"
            >
              Back to Login?
            </a>
          </div>

        </form>
      </div>
    </main>
  );
}
